// ─── @deprecated ────────────────────────────────────────────────────────
// Helpers y mappers legacy usados por useStatisticsData.js → StatisticsModulePage.
// Trabajan con 4 sexos (MUJER, HOMBRE, INTERSEXUAL, SE IGNORA) y endpoints legacy.
// Reemplazados por los mappers G1-G10 (Patrones A-E) al final de este archivo.
// TODO: eliminar junto con useStatisticsData.js, StatisticsModulePage.jsx,
//       EstadisticasCI.jsx, EstadisticasCLB.jsx y statsModuleConfig.js.
// ────────────────────────────────────────────────────────────────────────
// const GENDER_ORDER = ["MUJER", "HOMBRE", "INTERSEXUAL", "SE IGNORA"];

// const createGenderMap = () => ({
//   HOMBRE: new Map(),
//   MUJER: new Map(),
//   INTERSEXUAL: new Map(),
//   "SE IGNORA": new Map(),
// });

// const toOrderedValues = (genderMap, key) =>
//   GENDER_ORDER.flatMap((gender) => genderMap[gender].get(key) || [0, 0]);

// const sortDesc = (a, b) => b - a;
// const sortByTotalDesc = (a, b) => b.total - a.total;

// const parseSexBreakdown = (desgloseSexo = []) => {
//   let hombre = 0;
//   let mujer = 0;
//   let intersexual = 0;
//   let seIgnora = 0;

//   desgloseSexo.forEach((sexoItem) => {
//     const sexo = sexoItem?.sexo_persona;
//     const total = sexoItem?.total || 0;

//     if (sexo === "HOMBRE") {
//       hombre = total;
//     }
//     if (sexo === "MUJER") {
//       mujer = total;
//     }
//     if (sexo === "INTERSEXUAL") {
//       intersexual = total;
//     }
//     if (sexo === "SE IGNORA") {
//       seIgnora = total;
//     }
//   });

//   return {
//     hombre,
//     mujer,
//     intersexual,
//     seIgnora,
//     total: mujer + hombre + intersexual + seIgnora,
//   };
// };

// export const mapLocatedMunicipalityData = (data = [], municipalities = []) => {
//   const municipioData = [];
//   const otrosData = {
//     label: "Otros",
//     values: [0, 0, 0, 0],
//     total: 0,
//   };

//   data.forEach((municipioItem) => {
//     const municipio = municipioItem?.municipio_localizacion;
//     const { mujer, hombre, intersexual, seIgnora, total } = parseSexBreakdown(
//       municipioItem?.desglose_sexo || []
//     );

//     if (municipalities.includes(municipio)) {
//       municipioData.push({
//         label: municipio,
//         values: [mujer, hombre, intersexual, seIgnora],
//         total,
//       });
//       return;
//     }

//     otrosData.values[0] += mujer;
//     otrosData.values[1] += hombre;
//     otrosData.values[2] += intersexual;
//     otrosData.values[3] += seIgnora;
//     otrosData.total += total;
//   });

//   municipioData.sort(sortByTotalDesc);

//   if (otrosData.total > 0) {
//     municipioData.push(otrosData);
//   }

//   return municipioData;
// };

// export const mapMissingMunicipalityData = (data = [], municipalities = []) => {
//   const municipioData = [];
//   const otrosData = {
//     label: "Otros",
//     values: [0, 0, 0, 0],
//     total: 0,
//   };

//   data.forEach((municipioItem) => {
//     const municipio = municipioItem?.municipio_desaparicion;
//     const { mujer, hombre, intersexual, seIgnora, total } = parseSexBreakdown(
//       municipioItem?.desglose_sexo || []
//     );

//     if (municipalities.includes(municipio)) {
//       municipioData.push({
//         label: `${municipio || ""}`,
//         values: [mujer, hombre, intersexual, seIgnora],
//         total,
//       });
//       return;
//     }

//     otrosData.values[0] += mujer;
//     otrosData.values[1] += hombre;
//     otrosData.values[2] += intersexual;
//     otrosData.values[3] += seIgnora;
//     otrosData.total += total;
//   });

//   municipioData.sort(sortByTotalDesc);

//   if (otrosData.total > 0) {
//     municipioData.push(otrosData);
//   }

//   return municipioData;
// };

// export const mapLocatedYearConditionData = (data = {}) => {
//   const genderMap = createGenderMap();
//   const yearsData = [];

//   Object.keys(data).forEach((gender) => {
//     if (!genderMap[gender]) {
//       return;
//     }

//     const yearEntries = data[gender] || {};
//     const years = Object.keys(yearEntries);
//     yearsData.push(...years);

//     years.forEach((year) => {
//       let conVida = 0;
//       let sinVida = 0;

//       (yearEntries[year] || []).forEach((condition) => {
//         if (condition?.condicion_desc === "CON VIDA") {
//           conVida = condition.total || 0;
//         }
//         if (condition?.condicion_desc === "SIN VIDA") {
//           sinVida = condition.total || 0;
//         }
//       });

//       genderMap[gender].set(year, [conVida, sinVida]);
//     });
//   });

//   return [...new Set(yearsData)]
//     .sort(sortDesc)
//     .map((year) => ({
//       label: `${year}`,
//       values: toOrderedValues(genderMap, year),
//     }));
// };

// export const mapLocalizedAgeRangeData = (data = []) => {
//   const genderMap = createGenderMap();
//   const ageRanges = [];

//   data.forEach((item) => {
//     const gender = item?.sexo;
//     if (!genderMap[gender]) {
//       return;
//     }

//     (item?.desglose_rango_edad || []).forEach((ageItem) => {
//       const ageRange = ageItem?.rango_edad;
//       let conVida = 0;
//       let sinVida = 0;

//       (ageItem?.desglose_condicion_localizacion || []).forEach((condition) => {
//         if (condition?.cat_condicion_localizacion_id === "CON VIDA") {
//           conVida = condition.total || 0;
//         }
//         if (condition?.cat_condicion_localizacion_id === "SIN VIDA") {
//           sinVida = condition.total || 0;
//         }
//       });

//       if (ageRange) {
//         ageRanges.push(ageRange);
//         genderMap[gender].set(ageRange, [conVida, sinVida]);
//       }
//     });
//   });

//   return [...new Set(ageRanges)].map((ageRange) => ({
//     label: `${ageRange}`,
//     values: toOrderedValues(genderMap, ageRange),
//   }));
// };

// export const mapLocatedCrimeData = (data = {}) => {
//   const genderMap = createGenderMap();
//   const yearsData = [];

//   Object.keys(data).forEach((gender) => {
//     if (!genderMap[gender]) {
//       return;
//     }

//     const yearEntries = data[gender] || {};
//     const years = Object.keys(yearEntries);
//     yearsData.push(...years);

//     years.forEach((year) => {
//       let victima = 0;
//       let noVictima = 0;

//       (yearEntries[year] || []).forEach((classification) => {
//         const desc = classification?.clasificacion_desc;
//         const total = classification?.total || 0;

//         if (desc === "SIN SER VICTIMA DE DELITO") {
//           noVictima = total;
//         }
//         if (desc === "VICTIMA DE DELITO CONTEMPLADO EN LA LEY GENERAL") {
//           victima = total;
//         }
//         if (desc === "VICTIMA DE DELITO DIVERSO") {
//           victima += total;
//         }
//       });

//       genderMap[gender].set(year, [victima, noVictima]);
//     });
//   });

//   return [...new Set(yearsData)]
//     .sort(sortDesc)
//     .map((year) => ({
//       label: `${year}`,
//       values: toOrderedValues(genderMap, year),
//     }));
// };

// export const mapMissingAgeRangeData = (data = []) => {
//   const genderMap = createGenderMap();
//   const ageRanges = [];

//   data.forEach((item) => {
//     const gender = item?.sexo;
//     if (!genderMap[gender]) {
//       return;
//     }

//     (item?.desglose_rango_edad || []).forEach((ageItem) => {
//       const ageRange = ageItem?.rango_edad;
//       let conViolencia = 0;
//       let sinViolencia = 0;

//       (ageItem?.desglose_uso_violencia || []).forEach((violenceItem) => {
//         const tipoViolencia = violenceItem?.uso_violencia_desaparicion;
//         const total = violenceItem?.total || 0;

//         if (tipoViolencia === "SI") {
//           conViolencia = total;
//         }
//         if (tipoViolencia === "NO" || tipoViolencia === "SE IGNORA") {
//           sinViolencia += total;
//         }
//       });

//       if (ageRange) {
//         ageRanges.push(ageRange);
//         genderMap[gender].set(ageRange, [conViolencia, sinViolencia]);
//       }
//     });
//   });

//   return [...new Set(ageRanges)].map((ageRange) => ({
//     label: `${ageRange}`,
//     values: toOrderedValues(genderMap, ageRange),
//   }));
// };

// export const mapMissingYearClassificationData = (data = {}) => {
//   const genderMap = createGenderMap();
//   const yearsData = [];

//   Object.keys(data).forEach((gender) => {
//     if (!genderMap[gender]) {
//       return;
//     }

//     const yearEntries = data[gender] || {};
//     const years = Object.keys(yearEntries);
//     yearsData.push(...years);

//     years.forEach((year) => {
//       let conViolencia = 0;
//       let sinViolencia = 0;

//       (yearEntries[year] || []).forEach((yearItem) => {
//         const tipoViolencia = yearItem?.uso_violencia_desaparicion;
//         const total = yearItem?.total || 0;

//         if (tipoViolencia === "SI") {
//           conViolencia = total;
//         }
//         if (tipoViolencia === "NO" || tipoViolencia === "SE IGNORA") {
//           sinViolencia += total;
//         }
//       });

//       genderMap[gender].set(year, [conViolencia, sinViolencia]);
//     });
//   });

//   return [...new Set(yearsData)]
//     .sort(sortDesc)
//     .map((year) => ({
//       label: `${year}`,
//       values: toOrderedValues(genderMap, year),
//     }));
// };

// ─── Mappers para nuevos endpoints (G1-G10) ────────────────────────────

// Patrón A (G1, G2): resultados[] → { anio, desglose_sexo[] }
export const mapYearBySex = (apiData) =>
  apiData.resultados
    .filter((item) => item.desglose_sexo.some((s) => s.total > 0))
    .map((item) => ({
      label: String(item.anio),
      values: [
        item.desglose_sexo.find((s) => s.sexo === "MUJER")?.total ?? 0,
        item.desglose_sexo.find((s) => s.sexo === "HOMBRE")?.total ?? 0,
      ],
    }));

// Patrón B (G3): resultados[] → { HOMBRE: { year: [{uso_violencia, total}] }, MUJER: {...} }
export const mapViolenceBySexAndYear = (apiData) => {
  const years = [
    ...new Set([
      ...Object.keys(apiData.resultados.HOMBRE || {}),
      ...Object.keys(apiData.resultados.MUJER || {}),
    ]),
  ];

  years.sort((a, b) => {
    const numA = parseInt(a);
    const numB = parseInt(b);
    if (isNaN(numA)) return -1;
    if (isNaN(numB)) return 1;
    return numA - numB;
  });

  const findTotal = (sexData, tipo) =>
    (sexData || []).find((v) => v.uso_violencia_desaparicion === tipo)?.total ??
    0;

  return years
    .filter((year) => {
      const h = apiData.resultados.HOMBRE?.[year] || [];
      const m = apiData.resultados.MUJER?.[year] || [];
      return h.some((v) => v.total > 0) || m.some((v) => v.total > 0);
    })
    .map((year) => ({
      label: year,
      values: [
        findTotal(apiData.resultados.MUJER?.[year], "SI"),
        findTotal(apiData.resultados.HOMBRE?.[year], "SI"),
        findTotal(apiData.resultados.MUJER?.[year], "NO"),
        findTotal(apiData.resultados.HOMBRE?.[year], "NO"),
      ],
    }));
};

// Patrón C (G4, G5): resultados[] → { anio, desglose_rango_edad[] }
const AGE_GROUPS = [
  { name: "0-14", ranges: ["0-4", "5-9", "10-14"] },
  { name: "15-19", ranges: ["15-19"] },
  { name: "20-29", ranges: ["20-24", "25-29"] },
  { name: "30-39", ranges: ["30-34", "35-39"] },
  { name: "40-49", ranges: ["40-44", "45-49"] },
  {
    name: "50+",
    ranges: [
      "50-54", "55-59", "60-64", "65-69", "70-74",
      "75-79", "80-84", "85-89", "90-94", "95+",
      "rango de edad desconocido",
    ],
  },
];

export const mapYearByAgeRange = (apiData) =>
  apiData.resultados
    .filter((item) => item.desglose_rango_edad.some((r) => r.total > 0))
    .map((item) => {
      const totals = Object.fromEntries(
        item.desglose_rango_edad.map((r) => [r.rango_edad, r.total])
      );
      return {
        label: String(item.anio),
        values: AGE_GROUPS.map((group) =>
          group.ranges.reduce((sum, range) => sum + (totals[range] ?? 0), 0)
        ),
      };
    });

// Patrón D (G6, G9, G10): resultados[] → { condicion, desglose_victimizacion[] }
export const mapConditionByCrime = (apiData) =>
  apiData.resultados.map((item) => ({
    label: item.condicion,
    values: [
      item.desglose_victimizacion.find(
        (v) => v.victimizacion === "No víctimas de delito"
      )?.total ?? 0,
      item.desglose_victimizacion.find(
        (v) => v.victimizacion === "Víctimas de delito diverso"
      )?.total ?? 0,
      item.desglose_victimizacion.find((v) =>
        v.victimizacion?.includes("Ley General")
      )?.total ?? 0,
    ],
  }));

// Patrón E (G7, G8): resultados[] → { anio, porcentaje_localizacion }
export const mapPercentageByYear = (apiData) =>
  apiData.resultados
    .filter((item) => item.porcentaje_localizacion > 0)
    .map((item) => ({
      label: String(item.anio),
      values: [item.porcentaje_localizacion],
    }));

// ─── Footnote Formatters ────────────────────────────────────────────

const formatNumber = (n) => n.toLocaleString("es-MX");

// G1/G2: anteriores_2019 con desglose_sexo
export const formatFootnoteSexBreakdown = (anteriores) => {
  if (!anteriores?.desglose_sexo) return null;
  const hombre =
    anteriores.desglose_sexo.find((s) => s.sexo === "HOMBRE")?.total ?? 0;
  const mujer =
    anteriores.desglose_sexo.find((s) => s.sexo === "MUJER")?.total ?? 0;
  const total = formatNumber(hombre + mujer);
  return `Se tiene registro de ${total} desapariciones ocurridas antes de esa fecha: ${formatNumber(mujer)} mujeres y ${formatNumber(hombre)} hombres`;
};

// G3: anteriores_2019 con datos.HOMBRE/MUJER y violencia
export const formatFootnoteViolenceBreakdown = (anteriores) => {
  if (!anteriores?.datos) return null;
  const findTotal = (sexData, tipo) =>
    (sexData || []).find((v) => v.uso_violencia_desaparicion === tipo)?.total ??
    0;
  const hConViol = findTotal(anteriores.datos.HOMBRE, "SI");
  const hSinViol = findTotal(anteriores.datos.HOMBRE, "NO");
  const mConViol = findTotal(anteriores.datos.MUJER, "SI");
  const mSinViol = findTotal(anteriores.datos.MUJER, "NO");
  return `De las desapariciones ocurridas hasta el 31 de diciembre de 2018, se tiene registro de 
  ${formatNumber(mConViol)} mujeres desaparecidas con violencia, ${formatNumber(mSinViol)} mujeres desaparecidas sin violencia,
  ${formatNumber(hConViol)} hombres desaparecidos con violencia y ${formatNumber(hSinViol)} hombres desaparecidos sin violencia.`;
};

// G4/G5: anteriores_2019 con desglose_rango_edad, rangos individuales con texto por sexo
const FOOTNOTE_AGE_GROUPS = [
  { name: "0-4", ranges: ["0-4"] },
  { name: "5-9", ranges: ["5-9"] },
  { name: "10-14", ranges: ["10-14"] },
  { name: "15-19", ranges: ["15-19"] },
  { name: "20-29", ranges: ["20-24", "25-29"] },
  { name: "30-39", ranges: ["30-34", "35-39"] },
  { name: "40-49", ranges: ["40-44", "45-49"] },
  { name: "+50", ranges: ["50-54","55-59","60-64","65-69","70-74","75-79","80-84","85-89","90-94","95+","rango de edad desconocido"] },
];

export const formatFootnoteAgeBreakdown = (anteriores, sexo = "MUJER") => {
  if (!anteriores?.desglose_rango_edad) return null;
  const totals = Object.fromEntries(
    anteriores.desglose_rango_edad.map((r) => [r.rango_edad, r.total])
  );
  const label = sexo === "MUJER" ? "Las mujeres desaparecidas" : "Los hombres desaparecidos";
  const lines = FOOTNOTE_AGE_GROUPS.map(
    (group) =>
      `${group.name}: ${formatNumber(
        group.ranges.reduce((sum, range) => sum + (totals[range] ?? 0), 0)
      )}`
  );
  return [`${label} hasta el 31 de diciembre de 2018, se ubican en los siguientes rangos de edad:`, ...lines];
};

export const mapInvestigationCI = (apiData) => [
  { label: "C.I", values: [apiData.Con_Carpeta_Investigacion ?? 0] },
];

export const mapInvestigationReport = (apiData) => [
  { label: "Reporte", values: [apiData.Sin_Carpeta_Investigacion ?? 0] },
];
